import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {EventContainerProfileSearch} from "~/utilities/eventContainerProfileNavigation";
import {buildEventContainerProfileNavigateSearch} from "~/utilities/eventContainerProfileNavigation";
import {resolveConfigJourneyProfileHref} from "~/workspaceConfig/configHref";

export function buildJourneyProfilePath(args: {
    workspaceId: Uuid;
    eventContainerId: Uuid;
    eventContainerTemplateId: Uuid;
    from?: string;
    search?: EventContainerProfileSearch;
}): string {
    const from = args.from ?? args.search?.from;
    const href = resolveConfigJourneyProfileHref({
        workspaceId: args.workspaceId,
        eventContainerId: args.eventContainerId,
        eventContainerTemplateId: args.eventContainerTemplateId,
        search: from === undefined ? undefined : {from},
    });
    if (href === null) {
        throw new Error(`No JourneyProfile config page in workspace ${args.workspaceId}`);
    }
    return href;
}

export function buildJourneyProfileNavigateSearch(from: string): EventContainerProfileSearch {
    return buildEventContainerProfileNavigateSearch(from);
}
